export enum LanguageCodes {
  enUS = 'en-US',
  enGB = 'en-GB',
  daDK = 'da-DK',
  frFR = 'fr-FR',
  itIT = 'it-IT',
  es419 = 'es-419',
  deDE = 'de-DE',
  esES = 'es-ES',
  fiFI = 'fi-FI',
  koKR = 'ko-KR',
  nlNL = 'nl-NL',
  zhTW = 'zh-TW',
}
